var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spotlight",class:{
      'spotlight--expanded': _vm.expanded,
      'spotlight--disabled': !_vm.enabled
    },on:{"!click":function($event){return _vm.onClick($event)}}},[_c('div',{staticClass:"spotlight__spotlight",style:({ background: _vm.background })}),_c('div',{staticClass:"spotlight__content black--text"},[_c('div',{staticClass:"spotlight__content__inner"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }